import React, { Component } from 'react';
import FacebookLogin from 'react-facebook-login';
import { facebook_get_access_token_api } from 'Api/Api';
// , HeaderConfig, user_Registration, twitter_api, grabFromLocalStorage, 
import { origin, saveKey } from "utils/Helper";
import { local_routes } from 'utils/Routes';
import './style.css';

// wtf is happening here: https://06dccaf707974b5995eb3811a4f50dce.vfs.cloud9.us-east-1.amazonaws.com/login?code=AQShQ5NHYVYdM1A9pQ3yfyVqaeRdN3OVHzkW2YcKH-LcmRCVlztr1DZNvxoFbMIO3oVoE7WFzvWxn7FRlLQ7eDzY5j5hR2-yOrYCTv-onqczD4JlD_QaQQ8ALHDgxqERDdu_Iqd9DL0AO2HkCBi4p5wJxlYFG8XmeXH0gaS55NWW38dHaX4Sn_QuGk18uQ&state=fdsf78fyds7fm

import axios from "axios";

class Facebook_Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
            userID: '',
            name: '',
            email: '',
            picture: '',
            access_token: '',
            originData: window.localStorage.getItem('loginOrigin')
        };
    }

    //componentClicked = () => console.log('clicked')
    
    responseFacebook = (response) => {
        console.log("Facebook responseFacebook",response);
        let userData = [];
        if (response.status !== "unknown") {
            this.setState({
                userID: response.id,
                name: response.name,
                email: response.email,
                picture: response.picture.data.url,
                access_token: response.accessToken,
            })
        }
        if (response.id !== null && response.id !== undefined) {
            this.setState({
                isLoggedIn: true,
            })
            userData.push(response)
            this.getUserFbData(userData);
            //this.handleLangChange(userData);
        } else {
          // something did not work
          if (this.props.stopLoading) {
            this.props.stopLoading();
          }
          /*
          if (this.state.originData) {
              if (this.state.originData === "pkCreation") {
                  window.localStorage.removeItem('loginOrigin');
                  window.location.href = `${local_routes.pkcreation}`;
              } else {
                  // redirect back to loginOrigin
                  window.localStorage.removeItem('loginOrigin');
                  window.location.href = this.state.originData;
              }
          } else {
              window.location.href = origin;
          }
          */
        }
    }

    getUserFbData = async (userData) => {
        let resData = userData[0];
        let access_obj = { "access_token": resData.accessToken }
        const Json_access_Obj = JSON.stringify(access_obj);
        
        let response = await axios.post(facebook_get_access_token_api, Json_access_Obj);
        let UserData = { "UserMail": resData.email, "login_Auth_Res": response.data }
        saveKey("UserData", JSON.stringify(UserData));
        if (this.state.originData) {
            if (this.state.originData === "pkCreation") {
                window.localStorage.removeItem('loginOrigin');
                window.location.href = `${local_routes.pkcreation}`;
            } else {
                // redirect back to loginOrigin
                window.localStorage.removeItem('loginOrigin');
                window.location.href = this.state.originData;
            }
        } else {
            window.location.href = origin;
        }
        
        //grabFromLocalStorage();
        //window.location.href = '/';
        
        /*
        axios.post(facebook_get_access_token_api, Json_access_Obj, HeaderConfig)
            .then((response) => {
                let UserData = { "UserMail": resData.email, "login_Auth_Res": response.data, }
                saveKey("UserData", JSON.stringify(UserData));
                grabFromLocalStorage();
                window.location.href = origin;
            })
            .catch(() => {
            });
        */
    }
    
    /*
    handleLangChange = FBuserData => {
        this.props.ongetUserFbData(FBuserData);
    }
    */

    render() {
        // eslint-disable-next-line
        let fbContent;

        return (
            <div >
                {
                    fbContent = (
                        <div className="facebook-container">
                            <FacebookLogin
                                appId="2353602348296350"
                                autoLoad={false}
                                fields="name,email,picture"
                                // onChange={this.handleLangChange}
                                callback={this.responseFacebook}
                                cssClass="my-facebook-button-class"
                                icon="fa fa-facebook-square "
                                textButton="Facebook"
                            />
                        </div>
                    )
                }
            </div>
        );
    }
}

export default Facebook_Login;